import React from "react";

import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import ViewDocumentProfile from "../../../components/SidetabPages/Documents/ViewDocumentProfile";

const DocumentProfile = () => {
  return (
    <>
      <AnnouncementBar />
      <ViewDocumentProfile />
    </>
  );
};
export default DocumentProfile;
